import React, {
  useState,
  useContext,
  useImperativeHandle,
  useEffect
} from "react";

//api //add ons
import { gsap } from "gsap";

//components
import { viewportContext } from "../ViewportProvider";
import { DataContext } from "../DataContext.js";
import SearchField from "./search/SearchField.js";
import SearchResults from "./search/SearchResults.js";
import FilterResults from "./filter/FilterResults.js";
import Navigation from "./Navigation.js";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

import collapseBtn from "../assets/images/icons/collapse-search.svg";
import expandBtn from "../assets/images/icons/expand-search.svg";
//import { CollectionsOutlined } from "@material-ui/icons";

const BlueToolTip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#0016C7;",
    fontFamily: "Work Sans, sans",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: 0.5,
    padding: 10
  }
}))(Tooltip);

const ResultsModule = props => {
  const {
    mapRef,
    markerMap,
    currentView,
    visibleMarkers,
    nationalMarkers,
    currentLocation,
    searchUpdate,
    selectedResult,
    searchRef,
    togglePinsOff,
    updateCurrentView,
    updateMobileView,
    setSelectedMarker,
    currentSearchValue,
    selectedPinData
  } = props;

  const [searchResults] = useContext(DataContext);

  const useViewport = () => {
    const { isMobile } = useContext(viewportContext);
    return { isMobile };
  };
  const { isMobile } = useViewport();
  const [currentFilteredLocations, setCurrentFilteredLocations] = useState({});
  const [searchSlideSlide, setSearchSlideState] = useState(false);
  const [filtersCount, setFilterCount] = useState({ count: 0 });
  const [stateLocations, setStateMarkers] = useState([]);
  const [filteredItems, updateFilteredItems] = useState([]);
  const [nationalFilter, updateNationalFilters] = useState([]);
  const [resetFilters, updateResetFilters] = useState(null);
  //const [selectedPinData, updateSelectedPinData] = useState(null);
  //const [initViewClick, setInitViewClick] = useState(false);

  const handleUpdateView = view => {
    updateCurrentView(view);
  };

  useEffect(() => {
    handlefiltersUpdated(filteredItems);
  }, [visibleMarkers]);

  //get current state location from search
  useEffect(() => {
    var stateMarkersArray = [];

    if (searchResults[0] !== undefined) {
      for (var i = 0; i < searchResults[0].address_components.length; i++) {
        if (
          searchResults[0].address_components[i].types[0] ==
          "administrative_area_level_1"
        ) {
          var state = searchResults[0].address_components[i].short_name;

          //make state array list
          markerMap.map(marker => {
            if (state === marker[1].State) {
              //only push StateWide locations to the array
              if (marker[1].StateWide === true) {
                stateMarkersArray.push([marker[0], marker[1]]);
              }
            }
          }, []);
        }
      }
    }

    setStateMarkers(stateMarkersArray);
    //if search result is in a state that has a statewide location will pan to location on map
    if (stateMarkersArray.length !== 0) {
      let lat = stateMarkersArray[0][1].Latitude;
      let lng = stateMarkersArray[0][1].Longitude;
      mapRef.current.panTo({ lat, lng });
    }
  }, [searchResults]);

  useEffect(() => {
    updateMobileView(isMobile);
  }, [isMobile]);

  // useEffect(() => {
  //   console.log(selectedResult);
  // }),
  //   [selectedResult];

  const handleSearchUpdate = () => {
    //clear filters
    updateResetFilters(filtersCount);

    searchUpdate();
    updateCurrentView("searchView");
  };

  //set single result view
  useImperativeHandle(searchRef, () => ({
    handleResultView() {}
  }));

  const handlefiltersUpdated = filteredItems => {
    togglePinsOff(true);
    updateFilteredItems(filteredItems);
    //console.log(filteredItems);

    var noRepeatsFilteredArray = [];
    var currentVisibleMarkersIDs = [];
    var currentNationalIDs = [];
    var currentStateWideIDs = [];

    //get id's of visible items
    visibleMarkers.map(marker => {
      currentVisibleMarkersIDs.push(marker[1].ID);
    });

    //get id's of visible items
    nationalMarkers.map(marker => {
      //console.log("national marker: " + marker[1].ID);
      currentNationalIDs.push(marker[1].ID);
    });

    //get id's of stateWide items
    stateLocations.map(marker => {
      //console.log("state marker: " + marker[1].ID);
      currentStateWideIDs.push(marker[1].ID);
    });

    //remove filtered markers already present in visible marker state so there are no repeated results
    // noRepeatsFilteredArray = filteredItems.filter(item => {
    //   return currentVisibleMarkersIDs.indexOf(item[1].ID) == -1;
    // });

    //remove filtered markers already present in stateWide so there are no repeated results
    noRepeatsFilteredArray = filteredItems.filter(item => {
      return currentStateWideIDs.indexOf(item[1].ID) == -1;
    });

    // remove national markers already present in filtered markers
    noRepeatsFilteredArray = noRepeatsFilteredArray.filter(item => {
      return currentNationalIDs.indexOf(item[1].ID) == -1;
    });

    //console.log("noRepeatsFilteredArray: " + noRepeatsFilteredArray);
    //console.log("filteredItems: " + filteredItems);

    setCurrentFilteredLocations(noRepeatsFilteredArray);

    if (currentView.initialView !== true && currentView.expandView !== true) {
      updateCurrentView("searchView");
    }
  };

  const handleNationalfiltersUpdated = national => {
    updateNationalFilters(national);
  };

  const updateFiltersCount = count => {
    setFilterCount(count);
  };

  const toggleSearchSlide = () => {
    if (!searchSlideSlide) {
      let tl = gsap.timeline();
      tl.to(
        [".resultsModule"],
        {
          duration: 0.5,
          ease: "expo.out",
          css: { minWidth: "0px", width: "0%" }
        },
        "tl+=.25"
      );
      tl.to(
        ".mapModule",
        {
          duration: 0.5,
          width: "100%",
          ease: "expo.out"
        },
        "tl+=.25"
      );
      tl.to(
        [".searchField", ".searchResults", ".filterResults", ".navigation"],
        {
          duration: 0.5,
          opacity: 0,
          ease: "expo.out",
          x: "-100px"
        },
        "tl"
      );
      setSearchSlideState(true);
    } else {
      let tl = gsap.timeline();
      tl.to(
        [".resultsModule"],
        {
          duration: 0.5,
          width: "30%",
          ease: "expo.out",
          css: { minWidth: "426px", width: "30%" }
        },
        "tl"
      );
      tl.to(
        ".mapModule",
        {
          duration: 0.5,
          width: "70%",
          ease: "expo.out"
        },
        "tl"
      );
      tl.to(
        [".searchField", ".searchResults", ".filterResults", ".navigation"],
        {
          duration: 0.5,
          opacity: 1,
          ease: "expo.out",
          x: "0"
        },
        "tl+=.25"
      );
      setSearchSlideState(false);
    }
  };

  const handleCollapseView = () => {
    if (currentView.initialView !== true) {
      updateCurrentView("searchView");
    }
  };

  const handleMapView = () => {
    updateCurrentView("mapView");
    toggleSearchSlide();
  };

  return (
    <div className="resultsModule">
      {!isMobile && currentView.expandView ? (
        <div className={"collapseViewBtn"}>
          <Button onClick={handleCollapseView}>COLLAPSE VIEW</Button>
        </div>
      ) : null}
      {!isMobile ? (
        <div>
          {!searchSlideSlide ? (
            <BlueToolTip title="HIDE SEARCH BAR" placement="right" arrow>
              <button className="toggleSearchBtn" onClick={toggleSearchSlide}>
                <img alt="Left arrow pink icon" src={collapseBtn} />
              </button>
            </BlueToolTip>
          ) : (
            <BlueToolTip title="SHOW SEARCH BAR" placement="right" arrow>
              <button className="toggleSearchBtn" onClick={toggleSearchSlide}>
                <img alt="Right arrow pink icon" src={expandBtn} />
              </button>
            </BlueToolTip>
          )}
        </div>
      ) : null}

      {!isMobile ? (
        <SearchField
          mapRef={mapRef}
          onSearchSubmit={handleSearchUpdate}
          currentSearchValue={currentSearchValue}
        />
      ) : null}

      <Navigation
        updateView={handleUpdateView}
        isMobile={isMobile}
        filtersCount={filtersCount}
        currentView={currentView}
      />

      <div className="displayItems">
        <FilterResults
          markerMap={markerMap}
          currentLocation={currentLocation}
          currentView={currentView}
          nationalFilterUpdated={handleNationalfiltersUpdated}
          filtersUpdated={handlefiltersUpdated}
          filtersCount={updateFiltersCount}
          expandView={false}
          isMobile={isMobile}
          resetFilters={resetFilters}
          //togglePinsOff={togglePinsOff}
        />

        <SearchResults
          visibleResults={visibleMarkers}
          nationalMarkers={nationalMarkers}
          //initViewClick={initViewClick}
          nationalFilter={nationalFilter}
          stateLocations={stateLocations}
          results={currentFilteredLocations}
          currentView={currentView}
          currentLocation={currentLocation}
          updateMapView={handleMapView}
          selectedResult={selectedResult}
          isMobile={isMobile}
          //togglePinsOff={togglePinsOff}
          mapRef={mapRef}
          setSelectedMarker={setSelectedMarker}
          selectedPinData={selectedPinData}
        />
      </div>
    </div>
  );
};

export default ResultsModule;
